import './index.less'
import { Divider, Form, Button, Input } from 'ant-design-vue'
export default {
  name: 'FormSetEmail',
  props: Object.assign({
  }),
  created() {
    // 实例创建完成后被立即调用
    console.info('form created')
  },
  mounted() {
    // 实例被挂载后调用
    this.$nextTick(() => {
      // 整个视图都渲染完毕后执行
      console.info('form mounted')
    })
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'FormSetEmail' }),
      timer: '',
      waitSeconds: 0
    }
  },
  methods: {
    // 计时器
    resetWaitSeconds() {
      if (this.waitSeconds > 0) {
        this.waitSeconds = this.waitSeconds - 1
      }
    },
    handleCancel() {
      // 取消提交事件发出
      this.$emit('cancel')
      // 重置form内容
      this.form.resetFields()
    },
    handleSubmit(e) {
      // 表单提交事件发出
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('submit', values, this.form)
        }
      })
    },
    handelGetCode() {
      this.form.validateFields(['email'], async (err, values) => {
        if (!err) {
          console.info('values', values)
          var res = await this.$store.dispatch('GetValidCodeByEmail', values)
          if (!res.code) {
            this.waitSeconds = 60
            this.timer = setInterval(this.resetWaitSeconds, 1000)
          }
        }
      })
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  render() {
    const { getFieldDecorator } = this.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 22 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 22 },
        sm: { span: 16 }
      }
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0
        },
        sm: {
          span: 20,
          offset: 4
        }
      }
    }
    return (
      <div class='FormSetEmail'>
        <h3>
          设置邮箱</h3>
        <Divider style={{ margin: '20px 0 20px' }} />
        <Form form={this.form}
          labelCol={formItemLayout.labelCol}
          wrapperCol={formItemLayout.wrapperCol}
          onSubmit={this.handleSubmit} layout='horizontal'>
          <Form.Item label="邮箱" >
            {getFieldDecorator('email', {
              initialValue: '',
              ...this.$validator.email
            })(<Input placeholder='请输入邮箱' maxLength={20} />)}
          </Form.Item>
          <Form.Item label="验证码" >
            <div class='codeBox'>
              <div class='code'>
                {getFieldDecorator('code', {
                  initialValue: '',
                  rules: [{
                    required: true,
                    message: '请输入验证码'
                  }]
                })(<Input placeholder='请输入验证码' maxLength={20} />)}
              </div>
              <div class='codeBtn'>
                <Button
                  disabled={this.waitSeconds > 0}
                  type='primary'
                  onClick={this.handelGetCode.bind(this)}>
                  {this.waitSeconds <= 0 ? '获取验证码' : `${this.waitSeconds}秒后重新获取`}</Button>
              </div>
            </div>
          </Form.Item>
          <Form.Item
            labelCol={tailFormItemLayout.labelCol}
            wrapperCol={tailFormItemLayout.wrapperCol} >
            <div class='btnBroup'>
              <Button type="default" onClick={this.handleCancel}>
                取消
               </Button>
              <Button type="primary" htmlType="submit" class='btnItem'>
                确定
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div >
    )
  }
}
